let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7fBe0")).then(() => parcelRequire('bgS4M'));